// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Float from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Caml_array from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormDateInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/deprecated/FormDateInput.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as AllocationCampaignFooterCmp from "../../reusable-components/AllocationCampaignFooterCmp.bs.js";
import * as FormKeyInputTimeTs$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormKeyInputTimeTs.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";

var validators_maxDryRunDelta = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: undefined
            };
    })
};

var validators_maxDryRunAutomatic = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var maxDryRunAutomatic = param.maxDryRunAutomatic;
      if (maxDryRunAutomatic === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Automatic max dry run required"
              };
      }
      var value_before_and_after_decimal = maxDryRunAutomatic.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: maxDryRunAutomatic
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Automatic max dry should be greater than 0"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 10.75)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_maxDryRunManual = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var maxDryRunManual = param.maxDryRunManual;
      if (maxDryRunManual === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Manual max dry run required"
              };
      }
      var value_before_and_after_decimal = maxDryRunManual.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: maxDryRunManual
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Manual max dry should be greater than 0"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 10.75)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_dryRunDelta = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: undefined
            };
    })
};

var validators_dryRunRatio = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var dryRunRatio = param.dryRunRatio;
      if (dryRunRatio === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Dry run ratio required"
              };
      }
      var value_before_and_after_decimal = dryRunRatio.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: dryRunRatio
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Dry run ratio should be greater than 0"
                            };
                    } else if (filter > 2.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Dry run ratio should be less than or equal to 2"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 1.67)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_thresholdDistance = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var thresholdDistance = param.thresholdDistance;
      if (thresholdDistance === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Threshold distance required"
              };
      }
      var value_before_and_after_decimal = thresholdDistance.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: thresholdDistance
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Threshold distance should be greater than 0"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 10.75)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_allocationRadiusDelta = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: undefined
            };
    })
};

var validators_allocationRadiusAutomatic = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var allocationRadiusAutomatic = param.allocationRadiusAutomatic;
      if (allocationRadiusAutomatic === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Automatic allocation radius required"
              };
      }
      var value_before_and_after_decimal = allocationRadiusAutomatic.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: allocationRadiusAutomatic
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Automatic allocation radius should be greater than 0"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 10.75)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_allocationRadiusManual = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var allocationRadiusManual = param.allocationRadiusManual;
      if (allocationRadiusManual === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Manual allocation radius required"
              };
      }
      var value_before_and_after_decimal = allocationRadiusManual.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: allocationRadiusManual
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Manual allocation radius should be greater than 0"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 10.75)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_startTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var startTime = param.startTime;
      if (startTime !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(Caml_option.valFromOption(startTime))
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "A vaild time is required"
              };
      }
    })
};

var validators_startDate = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var startDate = param.startDate;
      if (startDate !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(Caml_option.valFromOption(startDate))
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Start date is required"
              };
      }
    })
};

var validators_campaignName = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var campaignName = param.campaignName;
      if (campaignName === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter Campaign name"
              };
      }
      var len = campaignName.length;
      if (len < 3) {
        return {
                TAG: /* Error */1,
                _0: "Campaign name cannot be less than 3 characters"
              };
      } else if (len > 60) {
        return {
                TAG: /* Error */1,
                _0: "Campaign name cannot be more than 60 characters"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: campaignName
              };
      }
    })
};

var validators = {
  maxDryRunDelta: validators_maxDryRunDelta,
  maxDryRunAutomatic: validators_maxDryRunAutomatic,
  maxDryRunManual: validators_maxDryRunManual,
  dryRunDelta: validators_dryRunDelta,
  dryRunRatio: validators_dryRunRatio,
  thresholdDistance: validators_thresholdDistance,
  allocationRadiusDelta: validators_allocationRadiusDelta,
  allocationRadiusAutomatic: validators_allocationRadiusAutomatic,
  allocationRadiusManual: validators_allocationRadiusManual,
  startTime: validators_startTime,
  startDate: validators_startDate,
  campaignName: validators_campaignName
};

function initialFieldsStatuses(_input) {
  return {
          maxDryRunDelta: /* Pristine */0,
          maxDryRunAutomatic: /* Pristine */0,
          maxDryRunManual: /* Pristine */0,
          dryRunDelta: /* Pristine */0,
          dryRunRatio: /* Pristine */0,
          thresholdDistance: /* Pristine */0,
          allocationRadiusDelta: /* Pristine */0,
          allocationRadiusAutomatic: /* Pristine */0,
          allocationRadiusManual: /* Pristine */0,
          startTime: /* Pristine */0,
          startDate: /* Pristine */0,
          campaignName: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.maxDryRunDelta;
  var match_0 = match ? match._0 : Curry._1(validators.maxDryRunDelta.validate, input);
  var match$1 = fieldsStatuses.maxDryRunAutomatic;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.maxDryRunAutomatic.validate, input);
  var match$2 = fieldsStatuses.maxDryRunManual;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.maxDryRunManual.validate, input);
  var match$3 = fieldsStatuses.dryRunDelta;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.dryRunDelta.validate, input);
  var match$4 = fieldsStatuses.dryRunRatio;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.dryRunRatio.validate, input);
  var match$5 = fieldsStatuses.thresholdDistance;
  var match_0$5 = match$5 ? match$5._0 : Curry._1(validators.thresholdDistance.validate, input);
  var match$6 = fieldsStatuses.allocationRadiusDelta;
  var match_0$6 = match$6 ? match$6._0 : Curry._1(validators.allocationRadiusDelta.validate, input);
  var match$7 = fieldsStatuses.allocationRadiusAutomatic;
  var match_0$7 = match$7 ? match$7._0 : Curry._1(validators.allocationRadiusAutomatic.validate, input);
  var match$8 = fieldsStatuses.allocationRadiusManual;
  var match_0$8 = match$8 ? match$8._0 : Curry._1(validators.allocationRadiusManual.validate, input);
  var match$9 = fieldsStatuses.startTime;
  var match_0$9 = match$9 ? match$9._0 : Curry._1(validators.startTime.validate, input);
  var match$10 = fieldsStatuses.startDate;
  var match_0$10 = match$10 ? match$10._0 : Curry._1(validators.startDate.validate, input);
  var match$11 = fieldsStatuses.campaignName;
  var match_0$11 = match$11 ? match$11._0 : Curry._1(validators.campaignName.validate, input);
  var maxDryRunDeltaResult = match_0;
  var maxDryRunDeltaResult$1;
  if (maxDryRunDeltaResult.TAG === /* Ok */0) {
    var maxDryRunAutomaticResult = match_0$1;
    if (maxDryRunAutomaticResult.TAG === /* Ok */0) {
      var maxDryRunManualResult = match_0$2;
      if (maxDryRunManualResult.TAG === /* Ok */0) {
        var dryRunDeltaResult = match_0$3;
        if (dryRunDeltaResult.TAG === /* Ok */0) {
          var dryRunRatioResult = match_0$4;
          if (dryRunRatioResult.TAG === /* Ok */0) {
            var thresholdDistanceResult = match_0$5;
            if (thresholdDistanceResult.TAG === /* Ok */0) {
              var allocationRadiusDeltaResult = match_0$6;
              if (allocationRadiusDeltaResult.TAG === /* Ok */0) {
                var allocationRadiusAutomaticResult = match_0$7;
                if (allocationRadiusAutomaticResult.TAG === /* Ok */0) {
                  var allocationRadiusManualResult = match_0$8;
                  if (allocationRadiusManualResult.TAG === /* Ok */0) {
                    var startTimeResult = match_0$9;
                    if (startTimeResult.TAG === /* Ok */0) {
                      var startDateResult = match_0$10;
                      if (startDateResult.TAG === /* Ok */0) {
                        var campaignNameResult = match_0$11;
                        if (campaignNameResult.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Valid */0,
                                  output: {
                                    campaignName: campaignNameResult._0,
                                    startDate: startDateResult._0,
                                    startTime: startTimeResult._0,
                                    allocationRadiusManual: allocationRadiusManualResult._0,
                                    allocationRadiusAutomatic: allocationRadiusAutomaticResult._0,
                                    allocationRadiusDelta: allocationRadiusDeltaResult._0,
                                    thresholdDistance: thresholdDistanceResult._0,
                                    dryRunRatio: dryRunRatioResult._0,
                                    dryRunDelta: dryRunDeltaResult._0,
                                    maxDryRunManual: maxDryRunManualResult._0,
                                    maxDryRunAutomatic: maxDryRunAutomaticResult._0,
                                    maxDryRunDelta: maxDryRunDeltaResult._0
                                  },
                                  fieldsStatuses: {
                                    maxDryRunDelta: /* Dirty */{
                                      _0: maxDryRunDeltaResult,
                                      _1: /* Shown */0
                                    },
                                    maxDryRunAutomatic: /* Dirty */{
                                      _0: maxDryRunAutomaticResult,
                                      _1: /* Shown */0
                                    },
                                    maxDryRunManual: /* Dirty */{
                                      _0: maxDryRunManualResult,
                                      _1: /* Shown */0
                                    },
                                    dryRunDelta: /* Dirty */{
                                      _0: dryRunDeltaResult,
                                      _1: /* Shown */0
                                    },
                                    dryRunRatio: /* Dirty */{
                                      _0: dryRunRatioResult,
                                      _1: /* Shown */0
                                    },
                                    thresholdDistance: /* Dirty */{
                                      _0: thresholdDistanceResult,
                                      _1: /* Shown */0
                                    },
                                    allocationRadiusDelta: /* Dirty */{
                                      _0: allocationRadiusDeltaResult,
                                      _1: /* Shown */0
                                    },
                                    allocationRadiusAutomatic: /* Dirty */{
                                      _0: allocationRadiusAutomaticResult,
                                      _1: /* Shown */0
                                    },
                                    allocationRadiusManual: /* Dirty */{
                                      _0: allocationRadiusManualResult,
                                      _1: /* Shown */0
                                    },
                                    startTime: /* Dirty */{
                                      _0: startTimeResult,
                                      _1: /* Shown */0
                                    },
                                    startDate: /* Dirty */{
                                      _0: startDateResult,
                                      _1: /* Shown */0
                                    },
                                    campaignName: /* Dirty */{
                                      _0: campaignNameResult,
                                      _1: /* Shown */0
                                    }
                                  },
                                  collectionsStatuses: undefined
                                };
                        }
                        maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                      } else {
                        maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                      }
                    } else {
                      maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                    }
                  } else {
                    maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                  }
                } else {
                  maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                }
              } else {
                maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
              }
            } else {
              maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
            }
          } else {
            maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
          }
        } else {
          maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
        }
      } else {
        maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
      }
    } else {
      maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
    }
  } else {
    maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            maxDryRunDelta: /* Dirty */{
              _0: maxDryRunDeltaResult$1,
              _1: /* Shown */0
            },
            maxDryRunAutomatic: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            maxDryRunManual: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            dryRunDelta: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            dryRunRatio: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            thresholdDistance: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            allocationRadiusDelta: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            allocationRadiusAutomatic: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            allocationRadiusManual: /* Dirty */{
              _0: match_0$8,
              _1: /* Shown */0
            },
            startTime: /* Dirty */{
              _0: match_0$9,
              _1: /* Shown */0
            },
            startDate: /* Dirty */{
              _0: match_0$10,
              _1: /* Shown */0
            },
            campaignName: /* Dirty */{
              _0: match_0$11,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurMaxDryRunDeltaField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.maxDryRunDelta, validators_maxDryRunDelta, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: status,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMaxDryRunAutomaticField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.maxDryRunAutomatic, validators_maxDryRunAutomatic, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: status,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMaxDryRunManualField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.maxDryRunManual, validators_maxDryRunManual, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: status,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDryRunDeltaField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.dryRunDelta, validators_dryRunDelta, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: status,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDryRunRatioField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.dryRunRatio, validators_dryRunRatio, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: status,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurThresholdDistanceField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.thresholdDistance, validators_thresholdDistance, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: status,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAllocationRadiusDeltaField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.allocationRadiusDelta, validators_allocationRadiusDelta, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: status,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAllocationRadiusAutomaticField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.allocationRadiusAutomatic, validators_allocationRadiusAutomatic, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: status,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAllocationRadiusManualField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.allocationRadiusManual, validators_allocationRadiusManual, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: status,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartTimeField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.startTime, validators_startTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: status,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartDateField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.startDate, validators_startDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: status,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCampaignNameField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.campaignName, validators_campaignName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  maxDryRunDelta: init.maxDryRunDelta,
                                  maxDryRunAutomatic: init.maxDryRunAutomatic,
                                  maxDryRunManual: init.maxDryRunManual,
                                  dryRunDelta: init.dryRunDelta,
                                  dryRunRatio: init.dryRunRatio,
                                  thresholdDistance: init.thresholdDistance,
                                  allocationRadiusDelta: init.allocationRadiusDelta,
                                  allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                  allocationRadiusManual: init.allocationRadiusManual,
                                  startTime: init.startTime,
                                  startDate: init.startDate,
                                  campaignName: status
                                };
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */12 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */12,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */13,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */15);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */14);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */13 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */14 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */15 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateMaxDryRunDeltaField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.maxDryRunDelta, state.submissionStatus, validators_maxDryRunDelta, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: status,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMaxDryRunAutomaticField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.maxDryRunAutomatic, state.submissionStatus, validators_maxDryRunAutomatic, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: status,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMaxDryRunManualField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.maxDryRunManual, state.submissionStatus, validators_maxDryRunManual, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: status,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDryRunDeltaField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.dryRunDelta, state.submissionStatus, validators_dryRunDelta, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: status,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDryRunRatioField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.dryRunRatio, state.submissionStatus, validators_dryRunRatio, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: status,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateThresholdDistanceField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, state.fieldsStatuses.thresholdDistance, state.submissionStatus, validators_thresholdDistance, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: status,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAllocationRadiusDeltaField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$6, state.fieldsStatuses.allocationRadiusDelta, state.submissionStatus, validators_allocationRadiusDelta, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: status,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAllocationRadiusAutomaticField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$7, state.fieldsStatuses.allocationRadiusAutomatic, state.submissionStatus, validators_allocationRadiusAutomatic, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: status,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAllocationRadiusManualField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$8, state.fieldsStatuses.allocationRadiusManual, state.submissionStatus, validators_allocationRadiusManual, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: status,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartTimeField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$9, state.fieldsStatuses.startTime, state.submissionStatus, validators_startTime, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: status,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartDateField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$10, state.fieldsStatuses.startDate, state.submissionStatus, validators_startDate, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: status,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCampaignNameField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$11, state.fieldsStatuses.campaignName, state.submissionStatus, validators_campaignName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            maxDryRunDelta: init.maxDryRunDelta,
                                            maxDryRunAutomatic: init.maxDryRunAutomatic,
                                            maxDryRunManual: init.maxDryRunManual,
                                            dryRunDelta: init.dryRunDelta,
                                            dryRunRatio: init.dryRunRatio,
                                            thresholdDistance: init.thresholdDistance,
                                            allocationRadiusDelta: init.allocationRadiusDelta,
                                            allocationRadiusAutomatic: init.allocationRadiusAutomatic,
                                            allocationRadiusManual: init.allocationRadiusManual,
                                            startTime: init.startTime,
                                            startDate: init.startDate,
                                            campaignName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */12 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */13 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */14 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateMaxDryRunDelta: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMaxDryRunDeltaField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMaxDryRunAutomatic: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMaxDryRunAutomaticField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMaxDryRunManual: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMaxDryRunManualField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDryRunDelta: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDryRunDeltaField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDryRunRatio: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDryRunRatioField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateThresholdDistance: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateThresholdDistanceField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAllocationRadiusDelta: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAllocationRadiusDeltaField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAllocationRadiusAutomatic: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAllocationRadiusAutomaticField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAllocationRadiusManual: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAllocationRadiusManualField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartTimeField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartDate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartDateField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCampaignName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCampaignNameField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurMaxDryRunDelta: (function (param) {
              return Curry._1(dispatch, /* BlurMaxDryRunDeltaField */0);
            }),
          blurMaxDryRunAutomatic: (function (param) {
              return Curry._1(dispatch, /* BlurMaxDryRunAutomaticField */1);
            }),
          blurMaxDryRunManual: (function (param) {
              return Curry._1(dispatch, /* BlurMaxDryRunManualField */2);
            }),
          blurDryRunDelta: (function (param) {
              return Curry._1(dispatch, /* BlurDryRunDeltaField */3);
            }),
          blurDryRunRatio: (function (param) {
              return Curry._1(dispatch, /* BlurDryRunRatioField */4);
            }),
          blurThresholdDistance: (function (param) {
              return Curry._1(dispatch, /* BlurThresholdDistanceField */5);
            }),
          blurAllocationRadiusDelta: (function (param) {
              return Curry._1(dispatch, /* BlurAllocationRadiusDeltaField */6);
            }),
          blurAllocationRadiusAutomatic: (function (param) {
              return Curry._1(dispatch, /* BlurAllocationRadiusAutomaticField */7);
            }),
          blurAllocationRadiusManual: (function (param) {
              return Curry._1(dispatch, /* BlurAllocationRadiusManualField */8);
            }),
          blurStartTime: (function (param) {
              return Curry._1(dispatch, /* BlurStartTimeField */9);
            }),
          blurStartDate: (function (param) {
              return Curry._1(dispatch, /* BlurStartDateField */10);
            }),
          blurCampaignName: (function (param) {
              return Curry._1(dispatch, /* BlurCampaignNameField */11);
            }),
          maxDryRunDeltaResult: Formality.exposeFieldResult(state.fieldsStatuses.maxDryRunDelta),
          maxDryRunAutomaticResult: Formality.exposeFieldResult(state.fieldsStatuses.maxDryRunAutomatic),
          maxDryRunManualResult: Formality.exposeFieldResult(state.fieldsStatuses.maxDryRunManual),
          dryRunDeltaResult: Formality.exposeFieldResult(state.fieldsStatuses.dryRunDelta),
          dryRunRatioResult: Formality.exposeFieldResult(state.fieldsStatuses.dryRunRatio),
          thresholdDistanceResult: Formality.exposeFieldResult(state.fieldsStatuses.thresholdDistance),
          allocationRadiusDeltaResult: Formality.exposeFieldResult(state.fieldsStatuses.allocationRadiusDelta),
          allocationRadiusAutomaticResult: Formality.exposeFieldResult(state.fieldsStatuses.allocationRadiusAutomatic),
          allocationRadiusManualResult: Formality.exposeFieldResult(state.fieldsStatuses.allocationRadiusManual),
          startTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.startTime),
          startDateResult: Formality.exposeFieldResult(state.fieldsStatuses.startDate),
          campaignNameResult: Formality.exposeFieldResult(state.fieldsStatuses.campaignName),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (!match.maxDryRunDelta && !match.maxDryRunAutomatic && !match.maxDryRunManual && !match.dryRunDelta && !match.dryRunRatio && !match.thresholdDistance && !match.allocationRadiusDelta && !match.allocationRadiusAutomatic && !match.allocationRadiusManual && !match.startTime && !match.startDate && !match.campaignName) {
                return false;
              }
              return true;
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */12);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */13);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */14);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */14,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */15);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialFormState(saved_value) {
  var value = saved_value.allocationRadiusManual;
  var value$1 = saved_value.allocationRadiusAutomatic;
  var value$2 = saved_value.allocationRadiusDelta;
  var value$3 = saved_value.thresholdDistance;
  var value$4 = saved_value.dryRunRatio;
  var value$5 = saved_value.dryRunDelta;
  var value$6 = saved_value.maxDryRunManual;
  var value$7 = saved_value.maxDryRunAutomatic;
  var value$8 = saved_value.maxDryRunDelta;
  return {
          campaignName: saved_value.campaignName,
          startDate: saved_value.startDate,
          startTime: saved_value.startTime,
          allocationRadiusManual: value !== undefined ? String(value) : undefined,
          allocationRadiusAutomatic: value$1 !== undefined ? String(value$1) : undefined,
          allocationRadiusDelta: value$2 !== undefined ? String(value$2) : undefined,
          thresholdDistance: value$3 !== undefined ? String(value$3) : undefined,
          dryRunRatio: value$4 !== undefined ? String(value$4) : undefined,
          dryRunDelta: value$5 !== undefined ? String(value$5) : undefined,
          maxDryRunManual: value$6 !== undefined ? String(value$6) : undefined,
          maxDryRunAutomatic: value$7 !== undefined ? String(value$7) : undefined,
          maxDryRunDelta: value$8 !== undefined ? String(value$8) : undefined
        };
}

function CreateMandatoryCampaignForm(Props) {
  var state = Props.state;
  var setFormStage = Props.setFormStage;
  var updatePreviewData = Props.updatePreviewData;
  var dispatch = Props.dispatch;
  console.log("preview data: ", state);
  var form = useForm(getInitialFormState(state), (function (output, _form) {
          var start_date = output.startDate;
          var start_time = new Date(Timestamp$Catalyst.toFloat(output.startTime));
          var fullYear = start_date.getFullYear();
          var month = start_date.getMonth();
          var day = start_date.getDate();
          var hour = start_time.getHours();
          var mins = start_time.getMinutes();
          var form_data_vehicle = state.vehicle;
          var form_data_geo_region = state.geo_region;
          var form_data_created_by = state.created_by;
          var form_data_campaignName = output.campaignName;
          var form_data_startDate = output.startDate;
          var form_data_startTime = Caml_option.some(Timestamp$Catalyst.make(Date.parse(new Date(fullYear, month, day, hour, mins).toString())));
          var form_data_allocationRadiusManual = output.allocationRadiusManual;
          var form_data_allocationRadiusAutomatic = output.allocationRadiusAutomatic;
          var form_data_allocationRadiusDelta = output.allocationRadiusDelta;
          var form_data_thresholdDistance = output.thresholdDistance;
          var form_data_dryRunRatio = output.dryRunRatio;
          var form_data_dryRunDelta = output.dryRunDelta;
          var form_data_maxDryRunManual = output.maxDryRunManual;
          var form_data_maxDryRunAutomatic = output.maxDryRunAutomatic;
          var form_data_maxDryRunDelta = output.maxDryRunDelta;
          var form_data = {
            vehicle: form_data_vehicle,
            geo_region: form_data_geo_region,
            created_by: form_data_created_by,
            created_on: undefined,
            campaignName: form_data_campaignName,
            startDate: form_data_startDate,
            startTime: form_data_startTime,
            endDate: undefined,
            endTime: undefined,
            allocationRadiusManual: form_data_allocationRadiusManual,
            allocationRadiusAutomatic: form_data_allocationRadiusAutomatic,
            allocationRadiusDelta: form_data_allocationRadiusDelta,
            thresholdDistance: form_data_thresholdDistance,
            dryRunRatio: form_data_dryRunRatio,
            dryRunDelta: form_data_dryRunDelta,
            maxDryRunManual: form_data_maxDryRunManual,
            maxDryRunAutomatic: form_data_maxDryRunAutomatic,
            maxDryRunDelta: form_data_maxDryRunDelta
          };
          Curry._1(updatePreviewData, (function (param) {
                  return form_data;
                }));
          return Curry._1(setFormStage, (function (param) {
                        return /* Preview */1;
                      }));
        }));
  var value = form.input.campaignName;
  var value$1 = form.input.allocationRadiusManual;
  var value$2 = form.input.allocationRadiusAutomatic;
  var value$3 = form.input.thresholdDistance;
  var value$4 = form.input.dryRunRatio;
  var value$5 = form.input.maxDryRunManual;
  var value$6 = form.input.maxDryRunAutomatic;
  return React.createElement("form", {
              className: "ald-create-campaign-form"
            }, React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Campaign Name", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateCampaignName, (function (input, value) {
                                            return {
                                                    campaignName: value,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "Enter Campaign Name", undefined, undefined, undefined, form.campaignNameResult, undefined, undefined, undefined, {
                            TAG: /* Text */0,
                            _0: "Campaign Names cannot be more than 60 characters"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value !== undefined ? value : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Start Date", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormDateInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), undefined, undefined, "Select the start date", undefined, undefined, undefined, form.startDateResult, undefined, "ald-create-form-item-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      date_props: {
                        value: form.input.startDate,
                        minDate: Caml_option.some(new Date(Date.now())),
                        maxDate: undefined,
                        onChange: (function (date) {
                            return Curry._2(form.updateStartDate, (function (input, value) {
                                          return {
                                                  campaignName: input.campaignName,
                                                  startDate: value,
                                                  startTime: input.startTime,
                                                  allocationRadiusManual: input.allocationRadiusManual,
                                                  allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                  allocationRadiusDelta: input.allocationRadiusDelta,
                                                  thresholdDistance: input.thresholdDistance,
                                                  dryRunRatio: input.dryRunRatio,
                                                  dryRunDelta: input.dryRunDelta,
                                                  maxDryRunManual: input.maxDryRunManual,
                                                  maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                  maxDryRunDelta: input.maxDryRunDelta
                                                };
                                        }), Caml_option.some(date));
                          }),
                        format: "DD MMM YYYY",
                        autoOk: true,
                        views: [
                          "year",
                          "month",
                          "date"
                        ]
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Start Time", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), undefined, undefined, "Select the start time", undefined, undefined, undefined, form.startTimeResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: ""
                          }, undefined, undefined, undefined, undefined, undefined),
                      time_props: {
                        value: form.input.startTime,
                        onChange: (function (date) {
                            return Curry._2(form.updateStartTime, (function (input, value) {
                                          return {
                                                  campaignName: input.campaignName,
                                                  startDate: input.startDate,
                                                  startTime: value,
                                                  allocationRadiusManual: input.allocationRadiusManual,
                                                  allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                  allocationRadiusDelta: input.allocationRadiusDelta,
                                                  thresholdDistance: input.thresholdDistance,
                                                  dryRunRatio: input.dryRunRatio,
                                                  dryRunDelta: input.dryRunDelta,
                                                  maxDryRunManual: input.maxDryRunManual,
                                                  maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                  maxDryRunDelta: input.maxDryRunDelta
                                                };
                                        }), date);
                          }),
                        format: "hh:mm A",
                        ampm: true,
                        isDisabled: false
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Allocation Radius Manual ", React.createElement("label", {
                          className: "unit"
                        }, "(km)"), React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateAllocationRadiusManual, (function (input, value) {
                                            return {
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: value,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "", undefined, undefined, undefined, form.allocationRadiusManualResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: "Value cannot be 0 or negative."
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value$1 !== undefined ? value$1 : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Allocation Radius Automatic ", React.createElement("label", {
                          className: "unit"
                        }, "(km)"), React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateAllocationRadiusAutomatic, (function (input, value) {
                                            return {
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: value,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "", undefined, undefined, undefined, form.allocationRadiusAutomaticResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: "Value cannot be 0 or negative."
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value$2 !== undefined ? value$2 : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Threshold Distance ", React.createElement("label", {
                          className: "unit"
                        }, "(km)"), React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateThresholdDistance, (function (input, value) {
                                            return {
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: value,
                                                    dryRunRatio: input.dryRunRatio,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "", undefined, undefined, undefined, form.thresholdDistanceResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: "Value cannot be 0 or negative."
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value$3 !== undefined ? value$3 : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Dry Run Ratio", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateDryRunRatio, (function (input, value) {
                                            return {
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: value,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "", undefined, undefined, undefined, form.dryRunRatioResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: "Enter value between 0 and 2"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value$4 !== undefined ? value$4 : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Max Dry Run Manual ", React.createElement("label", {
                          className: "unit"
                        }, "(km)"), React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateMaxDryRunManual, (function (input, value) {
                                            return {
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: value,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "", undefined, undefined, undefined, form.maxDryRunManualResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: "Value cannot be 0 or negative."
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value$5 !== undefined ? value$5 : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Max Dry Run Automatic ", React.createElement("label", {
                          className: "unit"
                        }, "(km)"), React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateMaxDryRunAutomatic, (function (input, value) {
                                            return {
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    allocationRadiusDelta: input.allocationRadiusDelta,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    dryRunDelta: input.dryRunDelta,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: value,
                                                    maxDryRunDelta: input.maxDryRunDelta
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "", undefined, undefined, undefined, form.maxDryRunAutomaticResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: "Value cannot be 0 or negative."
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value$6 !== undefined ? value$6 : ""
                      }
                    })), React.createElement(AllocationCampaignFooterCmp.make, {
                  onLeftBtnClick: (function (param) {
                      if (Curry._1(form.dirty, undefined)) {
                        return Curry._1(dispatch, {
                                    TAG: /* OpenModal */10,
                                    modal: {
                                      isOpen: true,
                                      onCancel: (function (param) {
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      onSubmit: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: /* UpdateSidebarState */6,
                                                opened_sidebar: /* CreateCampaignContainer */0
                                              });
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      title: "Discard Changes",
                                      confirm_button_title: "Yes, Discard",
                                      cancel_button_title: "No, Cancel",
                                      modal_body: "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?"
                                    }
                                  });
                      } else {
                        return Curry._1(dispatch, {
                                    TAG: /* UpdateSidebarState */6,
                                    opened_sidebar: /* CreateCampaignContainer */0
                                  });
                      }
                    }),
                  leftBtnText: "Back",
                  onRightBtnClick: (function (param) {
                      return Curry._1(form.submit, undefined);
                    }),
                  rightBtnText: "Preview"
                }));
}

var make = CreateMandatoryCampaignForm;

export {
  Form ,
  getInitialFormState ,
  make ,
  
}
/* react Not a pure module */
